import React from "react";
import PEPTable from "./PEPTable/PEPTable";

export default function PEPCard(props) {
    const { pep_data } = props
    const hasSource = Object.keys(pep_data?.source || {}).length > 0;
    if (!hasSource) return null;
    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                PEP - Pessoa Politicamente Exposta
            </p>
            <PEPTable pep_data={pep_data.source} />
        </div>
    )
}
